// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-ac3cfb10]{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:.625rem;width:1.25rem;height:1.25rem;border-radius:50%;font-family:\"Epilogue\",sans-serif;font-style:normal;font-weight:400;font-size:.625rem;line-height:.625rem;color:#fff;background-color:#860303}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
